import { useSelector } from 'react-redux';

import { isDebugModeEnabledSelector } from './selectors';

/** Return true if the debug mode was manually enabled  */
export const useIsDebugModeEnabled = () =>
  useSelector(isDebugModeEnabledSelector);
